import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

// Components
import LeadView from "../pages/LeadView/LeadView";

const router = new VueRouter({
    mode: '', //history
    base: '',
    routes: [
        {
            path: '/lead/:id',
            name: 'LeadView',
            component: LeadView,
            pathToRegexpOptions: {strict: true},
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {x: 0, y: 0}
        }
    }
});

export default router;
